import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import RoutineBuilder from './pages/RoutineBuilder';
import ExerciseLibrary from './pages/ExerciseLibrary';
import ExerciseEditor from './pages/ExerciseEditor';
import ActiveSession from './pages/ActiveSession';
import BodyStats from './pages/BodyStats';
import History from './pages/History';
import Youtube from './pages/Youtube';
import SqlPage from './pages/SqlPage';

// Simple Auth check (to be replaced with real context)
const ProtectedRoute = ({ children }) => {
  const user = localStorage.getItem('user');
  if (!user) {
    return <Navigate to="/login" replace />;
  }
  return children;
};

function App() {
  return (
    <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <div className="min-h-screen bg-[#121214] text-white">
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
          <Route path="/routine" element={<ProtectedRoute><RoutineBuilder /></ProtectedRoute>} />
          <Route path="/exercises" element={<ProtectedRoute><ExerciseLibrary /></ProtectedRoute>} />
          <Route path="/exercises/:id" element={<ProtectedRoute><ExerciseEditor /></ProtectedRoute>} />
          <Route path="/workout" element={<ProtectedRoute><ActiveSession /></ProtectedRoute>} />
          <Route path="/body" element={<ProtectedRoute><BodyStats /></ProtectedRoute>} />
          <Route path="/history" element={<ProtectedRoute><History /></ProtectedRoute>} />
          <Route path="/youtube" element={<ProtectedRoute><Youtube /></ProtectedRoute>} />
          <Route path="/sql" element={<ProtectedRoute><SqlPage /></ProtectedRoute>} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
